import _objectSpread from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/objectSpread2.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import PcMenu from 'src/widgets/global/pc-menu.vue';
import JFormAuto from 'src/components/j-form-auto.vue';
import PreSendTimeTag from '@/components/goods/preSendTimeTag.vue';
export default {
  inject: ['reload'],
  components: {
    PcMenu: PcMenu,
    JFormAuto: JFormAuto,
    PreSendTimeTag: PreSendTimeTag
  },
  data: function data() {
    return {
      keepLive: ['goods-list-id', 'cart', 'apply'],
      columns: [{
        name: 'goodsName',
        label: '商品信息'
      }, {
        name: 'preSendTimeLabel',
        label: '参考交期'
      }, {
        name: 'goodsPrice',
        label: '含税单价'
      }, {
        name: 'quantity',
        label: '数量 x 单位'
      }, {
        name: 'total',
        label: '含税小计( 元 )'
      }],
      config: [{
        required: true,
        label: '期望交货日期',
        name: 'data.requireInfo.requireTime',
        type: 'date'
      }, {
        required: true,
        label: '订制信息说明',
        name: 'data.requireInfo.requireOther',
        type: 'input',
        attrs: {
          type: 'textarea',
          autosize: {
            minRows: 6,
            maxRows: 8
          }
        }
      }, {
        label: '订制方案',
        name: 'data.requireInfo.customizedPlanList',
        type: 'upload',
        attrs: {
          accept: '',
          hint: '上传附件，支持图片、PDF、压缩包、word格式；大小不能超过2M'
        },
        rules: [{
          required: true,
          message: '请上传附件',
          type: 'array',
          trigger: 'blur'
        }]
      }, {
        label: '客户技术确认书',
        name: 'data.requireInfo.artConfirmationList',
        type: 'upload',
        attrs: {
          accept: '',
          hint: '上传附件，支持图片、PDF、压缩包、word格式；大小不能超过2M'
        },
        rules: [{
          required: true,
          message: '请上传附件',
          type: 'array',
          trigger: 'blur'
        }]
      }, {
        label: '定制图纸',
        name: 'data.requireInfo.customizedDrawingList',
        type: 'upload',
        attrs: {
          accept: '',
          hint: '上传附件，支持图片、PDF、压缩包、word格式；大小不能超过2M'
        },
        rules: [{
          required: true,
          message: '请上传附件',
          type: 'array',
          trigger: 'blur'
        }]
      }, {
        label: '附件',
        name: 'data.requireInfo.extendList',
        type: 'upload',
        attrs: {
          accept: '',
          hint: '上传附件，支持图片、PDF、压缩包、word格式；大小不能超过2M'
        },
        rules: [{
          required: true,
          message: '请上传附件',
          type: 'array',
          trigger: 'blur'
        }]
      }],
      dialogVisible: false,
      isShow: false,
      form: {
        data: {
          requireInfo: {
            customizedPlanList: [],
            artConfirmationList: [],
            customizedDrawingList: [],
            extendList: []
          }
        },
        disabled: false
      }
    };
  },
  mounted: function mounted() {
    if (!this.$store.state.isLogin) {
      var count = 0;
      var localCartList = this.lockr.get('cartList');
      localCartList && localCartList.length && localCartList.forEach(function (v, k) {
        if (!v.quantity) {
          localCartList.splice(k, 1);
        } else {
          count += v.quantity;
        }
      });
    }
    this.$store.dispatch('setCartCount', count);
  },
  methods: {
    sendForm: function sendForm() {
      var _this = this;
      if (!this.$store.state.isLogin) {
        this.$message.warning('请登录');
        this.$router.push('/login?redirect=' + window.location.pathname + window.location.search);
        return;
      }
      this.$refs.form.submit().then(function (_) {
        if (_this.form.id) {
          var form = _objectSpread({}, _this.form.data.requireInfo);
          _this.apiPut("/bbb/userCenter/userShoppingCar/updateRequire/".concat(_this.form.id), _objectSpread({}, form)).then(function (res) {
            if (res.code == 200) {
              _this.isShow = false;
              if (!_this.keepLive.includes(_this.$route.name)) {
                _this.reload();
              } else {
                _this.$bus.$emit('customization');
              }
              _this.$message.success('定制要求已修改');
            }
          });
        } else {
          var _form = {
            shopCarBizType: 30,
            skuGoodsList: [{
              requireInfo: _this.form.data.requireInfo,
              quantity: _this.form.data.goodsPriceUnitQuantity || 1,
              skuId: _this.mixEmpty(_this.form.data.skuItemDefault).skuId || _this.form.data.skuId,
              goodsId: _this.mixEmpty(_this.form.data.skuItemDefault).goodsId || _this.form.data.goodsId,
              goodsPriceUnit: _this.form.data.goodsPriceUnit,
              goodsPriceUnitName: _this.form.data.unitName || _this.form.data.goodsPriceUnitName
            }]
          };
          _this.apiPost('/bbb/userCenter/userShoppingCar/add', _objectSpread({}, _form)).then(function (res) {
            _this.isShow = false;
            _this.$store.dispatch('setCartCount');
            _this.$message.success('已经添加至购物车');
          });
        }
      });
    },
    handleClose: function handleClose() {
      this.$store.dispatch('showKf', false);
    },
    myTweak: function myTweak(offset) {
      return {
        minHeight: offset ? "calc(100vh - ".concat(offset, "px)") : '100vh'
      };
    }
  },
  created: function created() {},
  computed: {
    customForm: function customForm() {
      return this.$store.state.customForm;
    }
  },
  watch: {
    isShow: function isShow(val) {
      if (!val) {
        this.$store.commit('setCustomForm', {});
      }
    },
    customForm: function customForm(val) {
      var _this2 = this;
      if (Object.keys(val).length) {
        this.isShow = true;
        var data = JSON.parse(JSON.stringify(val));
        this.form = this.assignEmpty(this.form, _objectSpread(_objectSpread({}, data), {}, {
          data: _objectSpread(_objectSpread({}, val.data), {}, {
            requireInfo: this.assignEmpty(this.form.data.requireInfo, data.data.requireInfo || data.data.customizedRequire)
          })
        }));
        this.$nextTick(function () {
          var price = _this2.$refs.price.value;
          _this2.$set(_this2.form.data, 'total', _this2.form.data.quantity * (price || 0));
        });
      }
    },
    $route: function $route(to, from) {
      this.resetData('form');
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('customization');
  }
};